import React from "react";
import { Form, Formik } from "formik";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions, CourierText } from "../ui/courier-fields";

const CancelTripForm = ({
  closeModal,
  loading,
  apiError,
  trip,
  cancelCourierTrip
}) => (
  <FormModalShell title="Cancel Trip" apiError={apiError} onClose={closeModal} columns={1}>
    <Formik
      initialValues={{ reason: "" }}
      onSubmit={values => {
        cancelCourierTrip({
          id: trip.id,
          data: { reason: values.reason }
        });
      }}
    >
      {() => (
        <Form>
          <div className="form-row span-all">
            <p>Cancel trip {trip && trip.code}?</p>
          </div>
          <CourierText
            label="Reason (optional)"
            name="reason"
            placeholder="Reason for cancellation"
            span
          />
          <CourierActions
            loading={loading}
            submitLabel="Cancel Trip"
            onCancel={closeModal}
          />
        </Form>
      )}
    </Formik>
  </FormModalShell>
);

export default CancelTripForm;
